import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { PropertyDTO } from 'src/app/acl-data/general/property.dto';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { JsonPipe } from '@angular/common';
import { LegalCounselService } from 'src/app/acl-data/legal-counsel/legal-counsel.service';
import { map, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-audit-view',
    templateUrl: './audit-view.component.html',
    styleUrls: ['./audit-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditViewComponent implements OnChanges {
    @Input() audits: PropertyDTO[];
    @Input() objectStore: string;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    dataSource;
    displayedColumns: string[] = [
        'Creator',
        'DateCreated',
        'ClassDescription',
        'EventStatus',
        'Changes',
    ];
    constructor(
        private legalCounselService: LegalCounselService,
        private cdr: ChangeDetectorRef
    ) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.audits) {
            //Change the legal counsel ids to names
            this.audits.forEach(x =>{
                if (x["propertiesObj"].ClassDescription == "UpdateEvent"){
                    x["propertiesObj"].Changes.forEach(y =>{
                        if (y.fieldName == "ContractLegalCounsel"){
                            if(y.oldValue){
                                this.legalCounselService
                                .getLegalCounselById(y.oldValue)
                                /*.pipe(
                                    tap(v => console.log('Old Value lcSelected() > Legal Counsel for ' + y.oldValue, v)),
                                    take(1)
                                )*/
                                .subscribe(v => {
                                    y.oldValue = v["fullname"]
                                })
                            } else {
                                y.oldValue = "Unassigned"
                            }
                            if(y.newValue){
                                this.legalCounselService
                                .getLegalCounselById(y.newValue)
                                /*.pipe(
                                    tap(v => console.log('New Value lcSelected() > Legal Counsel for ' + y.newValue, v)),
                                    take(1)
                                )*/
                                .subscribe(v => {
                                    y.newValue = v["fullname"]
                                    this.cdr.detectChanges()
                                })
                            } else {
                                y.newValue = "Unassigned"
                            }
                        }

                    })
                }
            })
            this.dataSource = new MatTableDataSource<PropertyDTO>(this.audits);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.dataSource.filterPredicate = (
                data: PropertyDTO,
                filter: string
            ) => {
                if (!data) {
                    return false;
                }

                console.log(
                    JSON.stringify(data)
                        .toLowerCase()
                        .indexOf(filter) !== -1
                );
                return (
                    JSON.stringify(data)
                        .toLowerCase()
                        .indexOf(filter) !== -1
                );
            };
        }
        this.cdr.detectChanges()
    }

    applyFilter(filterValue: string) {
        console.log('Filter', filterValue.trim().toLowerCase());
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }
}
